"use client";

import { useWeb3 } from "logic/components";
import { useLoanDetails } from "logic/pages/LoansPage/LoanDetails/LoanDetailsProvider";
import { useLoansPage } from "logic/pages/LoansPage/LoansPageProvider";
import { bigIntMax, DEFAULT_DECIMALS, toUnits } from "logic/utils";
import { zeroAddress } from "viem";

import { BalanceCard } from "./BalanceCard";
import { WithdrawRAButton } from "./WithdrawRAButton";

export function BorrowerBalance() {
  const { loan, balances, tokens, reserveAccount, reservesRequired, setIsWithdrawModalOpen } = useLoanDetails();
  const { usdaiLocked } = useLoansPage();
  const { address: borrowerEoa = zeroAddress } = useWeb3();

  const dsraAmount = toUnits(loan.metadata.debtReserveAccount ?? 0, DEFAULT_DECIMALS);

  const pyusdPeerBalance = balances === null ? null : balances?.eoa.pyusdPeer;
  const pyusdMainBalance = balances === null ? null : balances?.eoa.pyusdMain;

  const usdaiMainBalance =
    balances?.eoa.usdaiMain !== undefined && usdaiLocked !== undefined
      ? bigIntMax(balances?.eoa.usdaiMain - usdaiLocked, 0n)
      : undefined;
  const availableUsdaiMainBalance = balances === null ? null : usdaiMainBalance;
  // The reserve account holds `required` back for upcoming payments, so only the remainder is available.
  const availableResAccUsdaiMainBalance =
    balances?.reserve.usdaiMain !== undefined && reservesRequired !== undefined
      ? bigIntMax(balances.reserve.usdaiMain - reservesRequired, 0n)
      : undefined;
  const resAccUsdaiMainBalance = balances === null ? null : availableResAccUsdaiMainBalance;

  return (
    <div className="flex gap-4 flex-wrap-reverse justify-end">
      <BalanceCard
        balanceLabel="Balance:"
        title="BORROWER WALLET"
        address={borrowerEoa}
        tokens={[
          { token: tokens.pyusd.main, amount: pyusdMainBalance },
          { token: tokens.pyusd.peer, amount: pyusdPeerBalance },
          { token: tokens.usdai.main, amount: availableUsdaiMainBalance },
        ]}
        button={
          pyusdPeerBalance ? (
            <button
              type="button"
              onClick={() => setIsWithdrawModalOpen(true)}
              className="btn-xs btn-primary ml-auto px-8"
            >
              Withdraw
            </button>
          ) : null
        }
      />

      <BalanceCard
        title="LOAN ACCOUNT"
        address={reserveAccount}
        hideAddress
        tokens={[{ token: tokens.usdai.main, amount: resAccUsdaiMainBalance }]}
        button={<WithdrawRAButton reserveAccount={reserveAccount} chainId={tokens.usdai.main.chainId} />}
      />

      {dsraAmount > 0n && (
        <BalanceCard
          title="DSRA"
          subTitle={loan.metadata.escrowed === "offchain" ? "Off-Chain" : undefined}
          address={borrowerEoa}
          hideAddress
          tokens={[{ token: tokens.usdai.main, amount: dsraAmount }]}
        />
      )}
    </div>
  );
}
